<script>
export default {
  name: 'MenuItem',
  functional: true,
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    num: {
      type: Number,
      default: 0
    }
  },
  render(h, context) {
    const { icon, title } = context.props
    const vnodes = []
    if (icon) {
      if (icon.includes('el-icon')) {
        vnodes.push(<i class={[icon, 'sub-el-icon']} />)
      } else if (icon.includes('icon')) {
        vnodes.push(<i class={['iconfont sub-el-icon', icon]} />)
      } else {
        vnodes.push(<svg-icon icon-class={icon} />)
      }
    }
    if (title) {
      vnodes.push(<span slot='title'>{title}</span>)
      // vnodes.push(<div class='flex-num'>{num}</div>)
    }
    return vnodes
  }
}
</script>

<style scoped>
.sub-el-icon {
  color: currentColor;
  width: 1em;
  height: 1em;
  font-size: 24px;
}
</style>
